import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from "../../../../utils/index";
import { ENDPOINTS } from "../../../../constants";
var ActionTypes = {
  FETCH_BALANCE: 'ub/fetch/balance',
  FETCH_FUB_GROUPS: 'fub/fetch/groups',
  MOBILE_CONNECTION_FETCH: 'connection/fetch',
  MOBILE_CONNECTION_PRICE_FETCH: 'connection/price/fetch',
  MOBILE_TARIFF_UP_POWER_FETCH: 'connection/tariffUpPower/fetch',
  MOBILE_TARIFF_UP_SUPERPOWER_FETCH: 'connection/tariffUpSuperPower/fetch',
  FTTB_CONNECTION_FETCH: 'connection/fttb/fetch',
  CONVERGENT_FETCH: 'connection/convergent/fetch',
  FETCH_BALANCES: 'ub/fetch/balances',
  SET_MAIN_BALANCE: 'ub/set/main/balance',
  SET_BONUS_BALANCE_DESCRIPTION: 'ub/set/balances/bonus/balanceDescription',
  SET_OPENED_MODAL: 'ub/set/balances/opened/modal',
  FETCH_TARIFF: 'tariff/fetchTariff',
  FETCH_ACCUMULATORS: 'accumulators/fetchAccumulators',
  FETCH_CONNECTION: 'connection/fetchConnection',
  REFRESH_TARIFF: 'tariff/block/refresh'
};
export var ConnectionBlockActionCreator = {
  fetchBalance: createAsyncThunk(ActionTypes.FETCH_BALANCE, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return apiClient.get(ENDPOINTS.fetchBalance);
        case 2:
          result = _context.sent;
          return _context.abrupt("return", result.data);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }))),
  fetchFubGroups: createAsyncThunk(ActionTypes.FETCH_FUB_GROUPS, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return apiClient.get(ENDPOINTS.fetchFubGroups);
        case 2:
          result = _context2.sent;
          return _context2.abrupt("return", result.data);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }))),
  fetchMobileConnection: createAsyncThunk(ActionTypes.MOBILE_CONNECTION_FETCH, function () {
    return apiClient.get(ENDPOINTS.mobileConnectionBlock).then(function (res) {
      return res.data;
    });
  }),
  fetchConnectionPrice: createAsyncThunk(ActionTypes.MOBILE_CONNECTION_PRICE_FETCH, function () {
    return apiClient.get(ENDPOINTS.mobileConnectionPrice).then(function (res) {
      return res.data;
    });
  }),
  fetchConnectionPower: createAsyncThunk(ActionTypes.MOBILE_TARIFF_UP_POWER_FETCH, function () {
    return apiClient.get(ENDPOINTS.mobileConnectionBlockTariffUpPower).then(function (res) {
      return res.data;
    });
  }),
  fetchConnectionSuperPower: createAsyncThunk(ActionTypes.MOBILE_TARIFF_UP_SUPERPOWER_FETCH, function () {
    return apiClient.get(ENDPOINTS.mobileConnectionBlockTariffUpSuperPower).then(function (res) {
      return res.data;
    });
  }),
  fetchFTTBConnection: createAsyncThunk(ActionTypes.FTTB_CONNECTION_FETCH, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return apiClient.get(ENDPOINTS.fttbTariff);
        case 2:
          result = _context3.sent;
          return _context3.abrupt("return", result.data);
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }))),
  fetchConvergent: createAsyncThunk(ActionTypes.CONVERGENT_FETCH, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var result;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return apiClient.get(ENDPOINTS.mainHome);
        case 2:
          result = _context4.sent;
          return _context4.abrupt("return", result.data);
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }))),
  fetchBalances: createAsyncThunk(ActionTypes.FETCH_BALANCES, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var result;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return apiClient.get(ENDPOINTS.fetchBalances);
        case 2:
          result = _context5.sent;
          return _context5.abrupt("return", result.data);
        case 4:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }))),
  setMainBalance: createAsyncThunk(ActionTypes.SET_MAIN_BALANCE, /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref6) {
      var balanceType, balanceCode, result;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            balanceType = _ref6.balanceType, balanceCode = _ref6.balanceCode;
            _context6.next = 3;
            return apiClient.put(ENDPOINTS.setMainBalance, {
              balanceType: balanceType,
              balanceCode: balanceCode
            });
          case 3:
            result = _context6.sent;
            return _context6.abrupt("return", result.data);
          case 5:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function (_x) {
      return _ref7.apply(this, arguments);
    };
  }()),
  setBonusBalanceDescription: createAction(ActionTypes.SET_BONUS_BALANCE_DESCRIPTION),
  setOpenedModal: createAction(ActionTypes.SET_OPENED_MODAL),
  fetchTariff: createAsyncThunk(ActionTypes.FETCH_TARIFF, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var result;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return apiClient.get(ENDPOINTS.fetchTariff);
        case 2:
          result = _context7.sent;
          return _context7.abrupt("return", result.data);
        case 4:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }))),
  fetchAccumulators: createAsyncThunk(ActionTypes.FETCH_ACCUMULATORS, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    var result;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return apiClient.get(ENDPOINTS.fetchAccumulators);
        case 2:
          result = _context8.sent;
          return _context8.abrupt("return", result.data);
        case 4:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }))),
  fetchConnection: createAsyncThunk(ActionTypes.FETCH_CONNECTION, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    var result;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return apiClient.get(ENDPOINTS.mobileConnectionPrice);
        case 2:
          result = _context9.sent;
          return _context9.abrupt("return", result.data);
        case 4:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  })))
};
export var refreshTariffBlock = createAsyncThunk(ActionTypes.REFRESH_TARIFF, /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_, _ref11) {
    var dispatch;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          dispatch = _ref11.dispatch;
          _context10.prev = 1;
          _context10.next = 4;
          return dispatch(ConnectionBlockActionCreator.fetchTariff());
        case 4:
          _context10.next = 6;
          return dispatch(ConnectionBlockActionCreator.fetchConnection());
        case 6:
          _context10.next = 11;
          break;
        case 8:
          _context10.prev = 8;
          _context10.t0 = _context10["catch"](1);
          throw new Error(_context10.t0);
        case 11:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[1, 8]]);
  }));
  return function (_x2, _x3) {
    return _ref12.apply(this, arguments);
  };
}());